import React from "react";
import PropTypes from "prop-types";

export function Card({ className = "", children, onClick, ...rest }) {
    // Use double layer to allow absolute positioned elements to float outside
    // container while still clipping statically positioned contents within
    // rounded borders
    return (
        <div
            className={`${onClick ? "ng-card--clickable" : ""} ${className}`}
            onClick={onClick}
            {...rest}
        >
            <article data-card-content="" className="ng-card__content">
                {children}
            </article>
            <style jsx>{`
                .ng-card__content {
                    border-radius: 10px;
                    box-shadow: 8px 8px 0px 3px rgba(0, 0, 0, 0.1);
                    background-color: #ffffff;
                    overflow: hidden;
                }
                .ng-card--clickable {
                    cursor: pointer;
                }
            `}</style>
        </div>
    );
}

Card.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
};

Card.defaultProps = {
    className: "",
    onClick: null,
};
